export default __webpack_public_path__ + "static/media/icon-phones-and-fax.5378d5a7.svg";